module.exports = __webpack_public_path__ + "img/red-pin.d9dc09a7.png";